import { ReactComponent as INBOX_TAB } from './icons/inbox-tab.svg';
import { ReactComponent as REPORT_TAB } from './icons/report-tab.svg';

export default { INBOX_TAB, REPORT_TAB };
